import { sprintf as originalSprintf } from 'sprintf-js';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function sprintf(str: string, ...args: any[]): string {
  try {
    return originalSprintf(str, ...args);
  } catch (e) {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.error('i18n', e);
    }

    // return string if sprintf failed
    // It is better to display unformatted string than break js at all
    return str;
  }
}
